import React from 'react';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import './register-info-page.css';
import {useNavigate} from 'react-router-dom';

interface IRegistrationInfoPageProps {
    isAuth: boolean;
    isAdmin: boolean;
    isSuperAdmin?: boolean;
}

const RegistrationInfoPage = ({isAuth, isAdmin, isSuperAdmin}: IRegistrationInfoPageProps): React.JSX.Element => {
    const navigate = useNavigate();
    const homeLink = isAuth ? (isAdmin ? '/kkm-control' : (isSuperAdmin ? '/admin' : '/home')) : '/';

    const serviceCenters: Record<string, {name: string; phone: string}[]> = {
        Актау: [{name: 'Сервис Центр Айко', phone: '+7 701 404 8997'}],
        Актобе: [{name: 'ИП "Newton Запад"', phone: '+7 701 950 5054'}],
        Алматы: [
            {name: 'ТОО ЦТО Адаптация', phone: '+7 708 970 5606'},
            {name: 'ИП Позитив', phone: '+7 700 983 2685, +7 727 240 1082'},
            {name: 'ИП Mega Service', phone: '+7 701 799 7731'},
            {name: 'ТОО "NEWTON COMPANY"', phone: '+7 705 345 2255, +7 777 375 2299'},
        ],
        Алтай: [{name: 'ТОО "Восток ФОРТ"', phone: '+7 707 464 4031'}],
        Аральск: [{name: 'ЦТО ИП "Абди"', phone: '+7 775 8463000'}],
        Аркалык: [{name: 'ИП "Алгоритм Сервис"', phone: '+7 7143 070437'}],
        Астана: [{name: 'ИП Пинчук (Бизнес РОСТ)', phone: '+7 776 956 0056'}],
        Атырау: [
            {name: 'ЦТО ZHAIK KZ', phone: '+7 701 0270008'},
            {name: 'INTEGRA', phone: '+7 701 9037951'}
        ],
        Караганда: [
            {name: 'ИП "ПЛЮСМИКРО ЦТО" Кнаус Е.А.', phone: '+7 777 193 1823'},
            {name: 'ТОО "RTL-Group"', phone: '+7 777 540 3350'}
        ],
        Кокшетау: [{name: 'MultiSoft', phone: '+7 701 8475784'}],
        Костанай: [
            {name: 'ТОО КостанайТехСервис+', phone: '+7 777 230 0924'},
            {name: 'ЦТО Меркурий', phone: '+7 777 363 3468'},
            {name: 'НОРД ТРЕЙДИНГ', phone: '+7 777 544 0660'},
            {name: 'ИП Попков А.А.', phone: '+7 777 363 3468'},
            {name: 'KST TECHNOLOGY', phone: '+7 776 472 0559'},
        ],
        Кызылорда: [{name: 'ИП Левин', phone: '+7 776 227 2326'}],
        Павлодар: [
            {name: 'MasterServicePVL', phone: '+7 778 942 8165'},
            {name: 'ТОО "ГК ПОРТ"', phone: '+7 777 865 3094'},
        ],
        Петропавловск: [
            {name: 'ТОО "ROMSERVISKASS"', phone: '+7 7162 525062'},
            {name: 'ТОО "ОКА"', phone: '+7 7152 466262'},
            {name: 'ЦТО "САМ"', phone: '+7 775 802 8881'},
        ],
        Приозёрск: [{name: 'ТОО "Прио-2050"', phone: '+7 747 1754504'}],
        Риддер: [{name: 'ТОО "ЦТО Мастер & К"', phone: '+7 701 512 8669'}],
        Рудный: [{name: 'ТОО "Интер КО"', phone: '+7 747 374 1354; +7 714 319 2955'}],
        Семей: [
            {name: 'ИП Молчанов С.В', phone: '+7 747 743 1876'},
            {name: 'ТОО Milady Сервис', phone: '+7 706 427 6767, +7 777 231 3465, +7 707 291 5555'},
            {name: 'ТОО "MILLTON"', phone: '+7 708 467 2917, +7 7222 672917'},
        ],
        Степногорск: [{name: 'ТОО "КассСервис"', phone: '+7 778 169 0531'}],
        Талдыкорган: [{name: 'ТОО ЦТО ОКА', phone: '+7 777 400 4747'}],
        Тараз: [{name: 'ТОО "ОРГТЕХ"', phone: '+7 7262 451406'}],
        Темиртау: [
            {name: 'Деркач Денис Леонидович ЦТО "АУРА"', phone: '+7 700 334 8009'},
            {name: 'ЦТО ИП Арищенко Г.А.', phone: '+7 701 394 6129'},
        ],
        Уральск: [
            {name: 'ИП ЦТО Касса Сервис', phone: '+7 707 876 2484'},
            {name: 'ТОО "ТОПАЗ-ИМПОРТ"', phone: '+7 776 919 0058'},
        ],
        'с. Урджар, область Абай, Урджарский район': [{name: 'ИП "Истемесов Д.С."', phone: '+7 87079962915'}],
        'Усть-Каменогорск': [
            {name: 'ТОО "Компания Фортшрит"', phone: '+7 7232 765807'},
            {name: 'ТОО Фортуна порт Восток', phone: '+7 7232 578504'},
            {name: 'ЦТО ТОО "Норфолк"', phone: '+7 777 222 5831'},
        ],
        Шемонаиха: [
            {name: 'ИП ВСВ', phone: '+7 705 5071798'},
            {name: 'ЦТО ЭлитСервис', phone: '+7 705 6393340'},
        ],
        Шымкент: [{name: 'ТОО Сервис Плюс', phone: '+7 700 451 4145'}],
    };

    const formatPhoneNumber = (raw: string): string => {
        // Удалим все лишние символы, кроме цифр и +
        const phones = raw.split(/[,;]+/).map(part => part.trim());

        return phones
            .map(phone => {
                const digits = phone.replace(/\D/g, '');
                if (digits.length === 11 && digits.startsWith('7')) {
                    return `+7 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
                }
                return phone; // Вернуть как есть, если не удаётся привести
            })
            .join(', ');
    };

    return (
        <>
            <a
                onClick={() => navigate(homeLink)}
                style={{
                    position: 'absolute',
                    top: '20px',
                    left: '20px',
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    color: '#fff',
                    fontSize: '16px',
                    cursor: 'pointer',
                }}
            >
                <HomeOutlinedIcon />
                <span>На главную</span>
            </a>
            <section className={'content'} style={{padding: '200px 0'}}>
                <div
                    style={{
                        width: '100%',
                        maxWidth: '800px',
                        margin: '0 auto',
                        backgroundColor: '#fff',
                        padding: '15px 30px',
                        borderRadius: '8px',
                    }}
                >
                    <h1 className={'title'}>Как зарегистрироваться?</h1>
                    <div className={'infoBlock'}>
                        <p style={{margin: '30px 0 70px 0', lineHeight: '140%'}}>
                            Чтобы пройти регистрацию в личном кабинете на АПК Портал, пожалуйста, свяжитесь с любым удобным для вас центром
                            технического обслуживания. Сотрудники центра проконсультируют вас и проведут все необходимые шаги для подключения.
                        </p>

                        <div className="city-cto-grid">
                            <a href={'https://kkmport.kz/gde-kupit'} target={'_blank'}>Список официальных центров технического обслуживания и их контакты.</a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default RegistrationInfoPage;
